import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, Sparkles } from 'lucide-react';
import { applyUpdateNow } from '@/serviceWorkerRegistration';

/**
 * Floating banner that appears when a new service-worker build is ready.
 * One click activates the new version: SW posts SKIP_WAITING → controllerchange
 * fires in serviceWorkerRegistration → page reloads automatically on the new
 * bundle.
 */
export default function UpdatePrompt() {
  const [visible, setVisible] = useState(false);
  const [applying, setApplying] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener('swUpdate', handler);
    return () => window.removeEventListener('swUpdate', handler);
  }, []);

  if (!visible) return null;

  const onClick = () => {
    setApplying(true);
    applyUpdateNow();
    // Safety net: if for any reason the controllerchange doesn't fire
    // within 4s (rare edge cases on iOS Safari), force a reload.
    setTimeout(() => {
      window.location.reload();
    }, 4000);
  };

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] max-w-md w-[calc(100%-2rem)]"
      role="alert"
      data-testid="sw-update-banner"
    >
      <div className="flex items-center gap-3 bg-surface border border-gold/40 rounded-2xl shadow-xl shadow-black/30 px-4 py-3">
        <div className="w-9 h-9 rounded-full bg-gold/20 flex items-center justify-center shrink-0">
          <Sparkles className="w-4 h-4 text-gold" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-foreground">Nova versão disponível</p>
          <p className="text-xs text-muted-foreground">Atualiza para veres as últimas alterações.</p>
        </div>
        <Button
          size="sm"
          onClick={onClick}
          disabled={applying}
          className="bg-ruby hover:bg-ruby-light text-white rounded-full"
          data-testid="sw-update-apply"
        >
          <RefreshCw className={`w-4 h-4 mr-1 ${applying ? 'animate-spin' : ''}`} />
          Atualizar
        </Button>
      </div>
    </div>
  );
}
